// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header.header-md::after,
ion-footer.footer-md::before {
  background-image: none;
}

ion-footer ion-toolbar {
  margin-top: -1px;
}

ion-toolbar {
  --border-width: 0 !important;
}

ion-content,
ion-toolbar {
  --background: var(--ion-color-primary);
}

.icon-close {
  width: 40px;
  height: 40px;
  float: right;
  margin-top: 24px;
  margin-right: 7px;
  cursor: pointer;
}

ion-content {
  --color: var(--ion-color-panel-text);
  text-align: center;
}
ion-content h1 {
  width: 281px;
  color: #293A4F;
  text-align: center;
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 41px;
  margin: 0 auto;
  margin-top: 62px;
}
ion-content ion-img {
  width: 230px;
  height: 230px;
  margin: 0 auto;
  margin-top: 30px;
  margin-bottom: 24px;
}
ion-content #img-footer-note {
  color: var(--body, #43556A);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
  margin-top: 29px;
  padding: 0px 60px;
}
ion-content #gmb-question {
  margin-top: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
ion-content #gmb-question #question-text {
  margin-top: 15px;
  font-size: 17px;
  font-weight: 500;
}
ion-content #gmb-question app-help-popover {
  --question-mark-color: black;
}
ion-content #question-text {
  margin-top: 15px;
  font-size: 17px;
  font-weight: 500;
}
ion-content ion-button {
  min-height: 64px;
  border-radius: 8px;
  margin-top: 48px;
  text-transform: none;
  font-size: 15px;
  font-weight: 600;
}
ion-content ion-button#skip-button {
  --color: var(--ion-color-primary-contrast);
  margin-top: 24px;
}
ion-content .cont-actions {
  padding: 0px 50px;
}
ion-content .btn-cancel {
  --background: #FFF;
  color: #0A8006;
  color: var(--ctasecundario, #0A8006);
  border: 2px solid #0A8006;
  border: 2px solid var(--ctasecundario, #0A8006);
  margin-top: 24px;
  margin-bottom: 24px;
}

@media (min-width: 960px) {
  ion-content ion-button {
    width: 35%;
    margin: 0 auto;
    margin-top: 48px;
  }
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/panel-core/lib/components/gmb-initial-component/gmb-initial-component.scss"],"names":[],"mappings":"AAAA;;EAEE,sBAAA;AACF;;AAEE;EACE,gBAAA;AACJ;;AAEA;EACE,4BAAA;AACF;;AACA;;EAEE,sCAAA;AAEF;;AACA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AAEF;;AACA;EACE,oCAAA;EACA,kBAAA;AAEF;AADE;EACE,YAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAGJ;AAAE;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AAEJ;AACE;EACE,2BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AACJ;AAEE;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAJ;AACI;EACE,gBAAA;EAEA,eAAA;EACA,gBAAA;AAAN;AAEI;EACE,4BAAA;AAAN;AAIE;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;AAFJ;AAKE;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;AAHJ;AAKI;EACE,0CAAA;EACA,gBAAA;AAHN;AAOE;EACE,iBAAA;AALJ;AAQE;EACE,kBAAA;EACA,cAAA;EACA,oCAAA;EACA,yBAAA;EACA,+CAAA;EACA,gBAAA;EACA,mBAAA;AANJ;;AAYA;EACE;IACE,UAAA;IACA,cAAA;IACA,gBAAA;EATF;AACF","sourcesContent":["ion-header.header-md::after,\nion-footer.footer-md::before {\n  background-image: none;\n}\nion-footer {\n  ion-toolbar {\n    margin-top: -1px;\n  }\n}\nion-toolbar {\n  --border-width: 0 !important;\n}\nion-content,\nion-toolbar {\n  --background: var(--ion-color-primary);\n}\n\n.icon-close{\n  width: 40px;\n  height: 40px;\n  float: right;\n  margin-top: 24px;\n  margin-right: 7px;\n  cursor: pointer;\n}\n\nion-content {\n  --color: var(--ion-color-panel-text);\n  text-align: center;\n  h1 {\n    width: 281px;\n    color: #293A4F;\n    text-align: center;\n    font-size: 28px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 41px;\n    margin: 0 auto;\n    margin-top: 62px;\n  }\n\n  ion-img {\n    width: 230px;\n    height: 230px;\n    margin: 0 auto;\n    margin-top: 30px;\n    margin-bottom: 24px;\n\n  }\n  #img-footer-note {\n    color: var(--body, #43556A);\n    text-align: center;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 21px;\n    margin-top: 29px;\n    padding: 0px 60px;\n  }\n\n  #gmb-question {\n    margin-top: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    #question-text {\n      margin-top: 15px;\n      //margin-left: 48px;\n      font-size: 17px;\n      font-weight: 500;\n    }\n    app-help-popover {\n      --question-mark-color: black;\n    }\n  }\n\n  #question-text {\n    margin-top: 15px;\n    font-size: 17px;\n    font-weight: 500;\n  }\n\n  ion-button {\n    min-height: 64px;\n    border-radius: 8px;\n    margin-top: 48px;\n    text-transform: none;\n    font-size: 15px;\n    font-weight: 600;\n\n    &#skip-button {\n      --color: var(--ion-color-primary-contrast);\n      margin-top: 24px;\n    }\n  }\n\n  .cont-actions{\n    padding: 0px 50px;\n  }\n\n  .btn-cancel{\n    --background: #FFF;\n    color: #0A8006;\n    color: var(--ctasecundario, #0A8006);\n    border: 2px solid #0A8006;\n    border: 2px solid var(--ctasecundario, #0A8006);\n    margin-top: 24px;\n    margin-bottom: 24px;\n  }\n}\n\n\n//PWA\n@media (min-width: 960px) {\n  ion-content ion-button {\n    width: 35%;\n    margin: 0 auto;\n    margin-top: 48px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
